
import { i18nText } from '@/locales';
import { RouterNameEnum } from '@/router/router.types'

export const BaseRoutes = [
  {path: '/register', name: RouterNameEnum.AuthRegister, component: ():any => import('@/UI/pages/auth/Register.vue'), meta: {title: i18nText("Регистрация компании — Пульт")}},
  {
    path: '/404',
    redirect: '/auth/login',
    component: ():any => import('@/UI/layouts/AuthLayout.vue'),
    meta: { auth: false }
  },
  {
    path: '/user',
    component: ():any => import('@/UI/pages/auth/User.vue'),
    meta: { auth: true }
  },
  {
    path: '/auth',
    redirect: '/auth/login',
    component: ():any => import('@/UI/layouts/AuthLayout.vue'),
    meta: { auth: false },
    children: [
      {
        path: 'login',
        name: RouterNameEnum.AuthLogin,
        meta: {
          title: i18nText("Логин - EPILIER")
        },
        component: ():any => import('@/UI/pages/auth/Login.vue')
      },

      {
        path: 'recover',
        name: RouterNameEnum.AuthRecover,
        meta: {
          title: i18nText("Восстановление пароля - EPILIER")
        },
        component: ():any => import('@/UI/pages/auth/Recover.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: '/dashboard'
    /* component: ():any => import('@/UI/layouts/MainLayout.vue'),
        meta: {
            auth: true,
        }, */
  }
]
